var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarElement2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 0l5.556 19.766L60.75 5.426l-5.072 19.896 19.896-5.072-14.34 14.694L81 40.5l-19.766 5.556 14.34 14.694-19.896-5.072 5.072 19.896-14.694-14.34L40.5 81l-5.556-19.766-14.694 14.34 5.072-19.896L5.426 60.75l14.34-14.694L0 40.5l19.766-5.556L5.426 20.25l19.896 5.072L20.25 5.426l14.694 14.34L40.5 0z",
    fill: "#FF7E5F"
  })));
}
export default SvgStarElement2;